export enum BookingType {
  Contracts = "contracts",
  Quotes = "quotes",
  Reservations = "reservations",
  AllInOne = "all-in-one-transactions"
}

export const BookingIdKey = {
  [BookingType.Contracts]: "contractNumber",
  [BookingType.Quotes]: "quoteNumber",
  [BookingType.Reservations]: "reservationNumber",
  [BookingType.AllInOne]: "transactionNumber"
} as const;

export const BookingPermission: Record<BookingType, Models.CompanyPermission> =
  {
    [BookingType.Contracts]: "view_contracts_sub",
    [BookingType.Quotes]: "view_quotations_rental",
    [BookingType.Reservations]: "view_reservations",
    [BookingType.AllInOne]: "all_in_one_transaction"
  };

export const UrlTypeToBookingTypeMap = {
  contract: BookingType.Contracts,
  reservation: BookingType.Reservations,
  quote: BookingType.Quotes,
  "all-in-one-transaction": BookingType.AllInOne
};

export const BookingUrl = {
  [BookingType.Contracts]: "/contracts/list",
  [BookingType.Quotes]: `/bookings/${BookingType.Quotes}/list`,
  [BookingType.Reservations]: `/bookings/${BookingType.Reservations}/list`,
  [BookingType.AllInOne]: `/bookings/${BookingType.AllInOne}/list`,
};

export const DRAFTS = {
    type: BookingType.Contracts,
    bookingIdKey: "contract_number",
    responseKey: "contract-drafts"
} as const;

export const ARCHIVES = {
    type: BookingType.Contracts,
    bookingIdKey: "contract_number",
    responseKey: "contract-archives"
} as const;

export const DivLocPermissions: Record<BookingType, Models.UserWarehousePermission> = {
  [BookingType.Contracts]: "view_contracts_sub",
  [BookingType.Quotes]: "view_quotations_rental",
  [BookingType.Reservations]: "view_reservations",
  [BookingType.AllInOne]: "all_in_one_transaction"
};

export const NO_SIGN = "0";
export type TDraft = (typeof DRAFTS)[keyof typeof DRAFTS];
export type TDraftResponseKey = TDraft["responseKey"];
